import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { BaseUrl } from "../../helper/BaseUrl";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import CustomSelect from "../../component/CustomSelect";

const caseEditEndpoint = ApiEndpoints.caseStudy.caseStudyEdit;
const caseUpdateEndpoint = ApiEndpoints.caseStudy.caseStudyUpdate;
const filterfetchEndpoint = ApiEndpoints.filters.List;
export default function CaseEdit() {
   const navigate = useNavigate();
   const { case_id } = useParams();
   const [selectedTags, setSelectedTags] = useState([]);
   const [tags, setTags] = useState([]);
   const [filters, setFilters] = useState([]);
   const [previews, setPreviews] = useState({ thumbnail: null, head_image: null });
   const [postData, setPostData] = useState({
      title: "",
      slug: "",
      short_description: "",
      thumbnail: null,
      alt_thumbnail: "",
      head_image: null,
      alt_head_image: "",
      use_case: "",
      topics: "",
      casestudy_solutions: "",
      region: "",
      problem_description: "",
      strategy_description: "",
      results_description: "",
      metrix_first_percentage: "",
      metrix_first_detail: "",
      metrix_second_percentage: "",
      metrix_second_detail: "",
      metrix_third_percentage: "",
      metrix_third_detail: "",
      description1: "",
      description2: "",
      specialty_id: "",
      provider_id: "",
      solution_id: "",
      tags: "",
      casestudy_id: case_id,
      banner_name: "",
      banner_heading: "",
      banner_description: "",
   });


   useEffect(() => {
      const fetchFilters = async () => {
         try {
            const response = await ApiRequest("GET", filterfetchEndpoint);
            setFilters(response || {});
         } catch (error) {
            console.error("Failed to fetch categories:", error);
            setFilters({});
         }
      };

      fetchFilters();
   }, []);


   const dataFetch = async () => {
      try {
         const response = await ApiRequest("GET", caseEditEndpoint + case_id);
         const result = response.casestudy;
         const tagResult = response.tags;
         setPostData((prev) => ({
            ...prev,
            ...result,
         }));
         setTags(tagResult);
         setSelectedTags(response?.casestudy?.tagDetails || []);
         setPreviews((prev) => ({
            ...prev,
            thumbnail: BaseUrl + result?.thumbnail || prev.thumbnail,
            head_image: BaseUrl + result?.head_image || prev.head_image,
         }));

      } catch (error) {
         console.log(error);
      }
   };


   useEffect(() => {
      dataFetch();
   }, []);


   const handleChange = (e) => {
      const { name, value, files } = e.target;

      if (files) {
         const file = files[0];
         // Update the previews state
         setPreviews((prev) => ({
            ...prev,
            [name]: URL.createObjectURL(file),
         }));

         // Update the postData state
         setPostData((prev) => ({
            ...prev,
            [name]: file,
         }));
      } else {
         setPostData((prev) => ({
            ...prev,
            casestudy_id: case_id,
            [name]: value,
         }));
      }
   };


   const handleEditorChange = (key, data) => {
      setPostData((prevState) => ({
         ...prevState,
         [key]: data,
      }));
   };


   // Submit handler
   const handleSubmit = async (e) => {
      e.preventDefault();

      for (const [key, value] of Object.entries(postData)) {
         if (key !=="description2" && key !=="description1" && key !== "solution_id" && key !== "provider_id" && key !== "specialty_id" && (value === "" || value === null)) {
            toast.error(`The field "${key}" is mandatory.`);
            return;
         }
      }
      const formData = new FormData();
      Object.entries(postData).forEach(([key, value]) => {
         if (key !== "tagDetails") {
            formData.append(key, value);
         }
      });

      try {
         const response = await ApiRequest("POST", caseUpdateEndpoint, formData, {
            headers: {
               "Content-Type": "multipart/form-data",
            },
         });
         toast.success(response.message);
         navigate("/case");
      } catch (error) {
         console.error("Error submitting form:", error);
      }
   };



   // ======================Tags Drag and Drop Functionality========================

   // Accepts array of IDs, array of objects, or comma string
   const handleTagSelectChange = (e) => {
      const { name, value } = e.target; // name should be "tag1"
      let newSelected = [];

      if (Array.isArray(value)) {
         if (value.length > 0 && typeof value[0] === "string") {
            // array of IDs -> map to tag objects from `tags` list
            newSelected = value
               .map((id) => tags.find((t) => t._id === id))
               .filter(Boolean);
         } else {
            // assume array of objects already
            newSelected = value;
         }
      } else if (typeof value === "string") {
         // maybe a comma-separated string "id1,id2"
         const ids = value ? value.split(",").map((s) => s.trim()).filter(Boolean) : [];
         newSelected = ids.map((id) => tags.find((t) => t._id === id)).filter(Boolean);
      } else {
         newSelected = [];
      }

      setSelectedTags(newSelected);

      // keep postData.tag1 as comma string for backend compatibility
      setPostData((prev) => ({
         ...prev,
         [name]: newSelected.map((t) => t._id).join(","),
      }));
   };

   // ------------------ Drag & Drop for tag chips ------------------
   const onDragStartTag = (e, index) => {
      e.dataTransfer.setData("text/plain", String(index));
      e.dataTransfer.effectAllowed = "move";
   };

   const onDragOverTag = (e) => {
      e.preventDefault(); // allow drop
      e.dataTransfer.dropEffect = "move";
   };

   const onDropTag = (e, dropIndex) => {
      e.preventDefault();
      const dragIndexStr = e.dataTransfer.getData("text/plain");
      if (!dragIndexStr) return;
      const dragIndex = parseInt(dragIndexStr, 10);
      if (isNaN(dragIndex) || dragIndex === dropIndex) return;

      setSelectedTags((prev) => {
         const next = Array.from(prev);
         const [moved] = next.splice(dragIndex, 1);
         next.splice(dropIndex, 0, moved);

         const ids = next.map((t) => t._id);
         setPostData((p) => ({
            ...p,
            tags: ids.join(","),
         }));

         return next;
      });
   };

   const removeTagAt = (index) => {
      setSelectedTags((prev) => {
         const next = prev.filter((_, i) => i !== index);
         const ids = next.map((t) => t._id);
         setPostData((p) => ({
            ...p,
            tags: ids.join(","),
         }));
         return next;
      });
   };

   const renderSelectedTagsChips = () => {
      if (!selectedTags || selectedTags.length === 0)
         return <div style={{ color: "#666", fontSize: 12, marginTop: 15 }}>SELECTED TAGS: (You can drag and drop them to change their order.)</div>;

      return (
         <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 15 }}>
            {selectedTags.map((t, i) => (
               <span key={t._id} draggable onDragStart={(e) => onDragStartTag(e, i)} onDragOver={onDragOverTag} onDrop={(e) => onDropTag(e, i)}
                  style={{
                     display: "inline-flex",
                     alignItems: "center",
                     gap: 8,
                     padding: "6px 10px",
                     borderRadius: 16,
                     border: "1px solid #d0d0d0",
                     background: "#fff",
                     cursor: "grab",
                     userSelect: "none",
                  }}
                  title={t.name || t.title}
               >
                  <span style={{ fontSize: 13 }}>{t.name || t.title}</span>
                  <button type="button" onClick={(ev) => { ev.stopPropagation(); removeTagAt(i); }}
                     style={{
                        border: "none",
                        background: "transparent",
                        padding: 0,
                        marginLeft: 4,
                        cursor: "pointer",
                        lineHeight: 1,
                        color: "red",
                     }}
                     aria-label={`Remove ${t.name || t.title}`}
                  >
                     ✕
                  </button>
               </span>
            ))}
         </div>
      );
   };

   // =====================Tag Drag and Drop End===================================



   const pagename = {
      name: 'Case Management',
      user: 'Admin',
      innerpage: 'Case Management / Case / Edit Case'
   }

   return (
      <>
         <AdminHeader pagename={pagename} />
         <div className="add-content-page">
            <form id="caseEdit" onSubmit={handleSubmit}>

               <div className="add-content-wrap">
                  <div className="row">

                     <div className="col-lg-6">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>title<small>*</small></label>
                           </div>
                           <input value={postData?.title} onChange={handleChange} name="title" type="text" className="form-control" placeholder="Enter Title" />
                        </div>
                     </div>

                     <div className="col-lg-6">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>slug<small>*</small></label>
                           </div>
                           <input value={postData?.slug} onChange={handleChange} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
                        </div>
                     </div>

                     <div className="col-lg-6">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>use case<small>*</small></label>
                           </div>
                           <input value={postData?.use_case} onChange={handleChange} name="use_case" type="text" className="form-control" placeholder="Enter use case" />
                        </div>
                     </div>

                     <div className="col-lg-6">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>Client<small>*</small></label>
                           </div>
                           <input value={postData?.topics} onChange={handleChange} name="topics" type="text" className="form-control" placeholder="Enter Client" />
                        </div>
                     </div>


                     <div className="col-lg-6">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>Casestudy Solutions <small>*</small></label>
                           </div>
                           <input value={postData?.casestudy_solutions} onChange={handleChange} name="casestudy_solutions" type="text" className="form-control" placeholder="Enter Casestudy Solutions " />
                        </div>
                     </div>

                     <div className="col-lg-6">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>region<small>*</small></label>
                           </div>
                           <input value={postData?.region} onChange={handleChange} name="region" type="text" className="form-control" placeholder="Enter region" />
                        </div>
                     </div>

                     <div className="col-lg-6">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>Solution<small></small></label>
                           </div>
                           <CustomSelect multiple defaultValue={postData.solution_id} onChange={handleChange} name="solution_id" options={filters?.solutions} placeholder="Select solution" />
                        </div>
                     </div>

                     <div className="col-lg-6">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>Specialty<small></small></label>
                           </div>
                           <CustomSelect multiple defaultValue={postData.specialty_id} onChange={handleChange} name="specialty_id" options={filters?.specialities} placeholder="Select specialty" />
                        </div>
                     </div>

                     <div className="col-lg-12">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>Provider<small></small></label>
                           </div>
                           <CustomSelect multiple defaultValue={postData.provider_id} onChange={handleChange} name="provider_id" options={filters?.providers} placeholder="Select provider" />
                        </div>
                     </div>

                     {/* Tags: MULTIPLE + DRAGGABLE CHIPS */}
                     <div className="col-lg-12">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>
                                 Select Tags<small>*</small>
                              </label>
                           </div>

                           <CustomSelect multiple defaultValue={postData.tags} onChange={handleTagSelectChange} name="tags" options={tags} placeholder="Select Tag Name" />

                           {/* Selected tags shown as draggable spans */}
                           {renderSelectedTagsChips()}
                        </div>
                     </div>
                  </div>
               </div>

               <div className="add-content-wrap">
                  <div className="row">

                     <div className="col-lg-4">
                        <div className="add-page-inputs case-metrix-wrap">
                           <div className="label-wrap-add">
                              <label>problem description<small>*</small></label>
                           </div>
                           <textarea value={postData?.problem_description} onChange={handleChange} name="problem_description" type="text" className="form-control" placeholder="Enter problem description" />
                        </div>
                     </div>

                     <div className="col-lg-4">
                        <div className="add-page-inputs case-metrix-wrap">
                           <div className="label-wrap-add">
                              <label>strategy description<small>*</small></label>
                           </div>
                           <textarea value={postData?.strategy_description} onChange={handleChange} name="strategy_description" type="text" className="form-control" placeholder="Enter strategy description" />
                        </div>
                     </div>

                     <div className="col-lg-4">
                        <div className="add-page-inputs case-metrix-wrap">
                           <div className="label-wrap-add">
                              <label>results description<small>*</small></label>
                           </div>
                           <textarea value={postData?.results_description} onChange={handleChange} name="results_description" type="text" className="form-control" placeholder="Enter result description" />
                        </div>
                     </div>

                     <div className="col-lg-4">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>metrix first percentage<small>*</small></label>
                           </div>
                           <input value={postData?.metrix_first_percentage} onChange={handleChange} name="metrix_first_percentage" type="text" className="form-control" placeholder="Enter metrix first percentage" />
                        </div>

                        <div className="add-page-inputs case-metrix-wrap">
                           <div className="label-wrap-add">
                              <label>metrix first detail<small>*</small></label>
                           </div>
                           <textarea value={postData?.metrix_first_detail} onChange={handleChange} name="metrix_first_detail" type="text" className="form-control" placeholder="Enter metrix first detail" />
                        </div>
                     </div>

                     <div className="col-lg-4">
                        <div className="add-page-inputs ">
                           <div className="label-wrap-add">
                              <label>metrix second percentage<small>*</small></label>
                           </div>
                           <input value={postData?.metrix_second_percentage} onChange={handleChange} name="metrix_second_percentage" type="text" className="form-control" placeholder="Enter metrix second percentage" />
                        </div>

                        <div className="add-page-inputs case-metrix-wrap">
                           <div className="label-wrap-add">
                              <label>metrix second detail<small>*</small></label>
                           </div>
                           <textarea value={postData?.metrix_second_detail} onChange={handleChange} name="metrix_second_detail" type="text" className="form-control" placeholder="Enter metrix second detail" />
                        </div>
                     </div>

                     <div className="col-lg-4">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>metrix third percentage<small>*</small></label>
                           </div>
                           <input value={postData?.metrix_third_percentage} onChange={handleChange} name="metrix_third_percentage" type="text" className="form-control" placeholder="Enter metrix third percentage" />
                        </div>

                        <div className="add-page-inputs case-metrix-wrap">
                           <div className="label-wrap-add">
                              <label>metrix third detail<small>*</small></label>
                           </div>
                           <textarea value={postData?.metrix_third_detail} onChange={handleChange} name="metrix_third_detail" type="text" className="form-control" placeholder="Enter metrix third detail" />
                        </div>
                     </div>

                  </div>
               </div>

               <div className="add-content-wrap">
                  <div className="row">
                     <div className="col-lg-12">
                        <div className="add-page-inputs input-add-image">
                           <div className="label-wrap-add">
                              <label>short description<small>*</small></label>
                           </div>
                           <input value={postData?.short_description} onChange={handleChange} name="short_description" type="text" className="form-control" placeholder="Enter short description" />
                        </div>
                     </div>

                     <div className="col-lg-6">
                        <div className="add-page-inputs input-add-image">
                           <div className="label-wrap-add">
                              <label>alt thumbnail<small>*</small></label>
                           </div>
                           <input value={postData?.alt_thumbnail} onChange={handleChange} name="alt_thumbnail" type="text" className="form-control" placeholder="Enter alt tag" />
                        </div>

                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>Thumbnail Image (466 × 256)<small>*</small></label>
                           </div>
                           <CustomImageUpload name="thumbnail"
                              acceptedFormats={[".webp"]}
                              onImageChange={handleChange}
                              imagePreview={previews.thumbnail} />
                        </div>
                     </div>

                     <div className="col-lg-6">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>alt head image<small>*</small></label>
                           </div>
                           <input value={postData?.alt_head_image} onChange={handleChange} name="alt_head_image" type="text" className="form-control" placeholder="Enter alt tag" />
                        </div>

                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>Head Image (678 × 630)<small>*</small></label>
                           </div>
                           <CustomImageUpload name="head_image"
                              acceptedFormats={[".webp"]}
                              onImageChange={handleChange}
                              imagePreview={previews.head_image} />
                        </div>
                     </div>
                  </div>
               </div>

               <div className="add-content-wrap">
                  <div className="row">

                     <div className="col-lg-6">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>description one<small></small></label>
                           </div>
                           <DynamicCKEditor data={postData.description1} onChange={(event, editor) =>
                              handleEditorChange("description1", editor.getData())} />
                        </div>
                     </div>

                     <div className="col-lg-6">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>description Two<small></small></label>
                           </div>
                           <DynamicCKEditor data={postData.description2} onChange={(event, editor) =>
                              handleEditorChange("description2", editor.getData())} />
                        </div>
                     </div>
                  </div>
               </div>


               <div className="add-content-wrap">
                  <div className="row">

                     <div className="col-lg-6">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>Form Banner Name<small>*</small></label>
                           </div>
                           <input value={postData?.banner_name} onChange={handleChange} name="banner_name" type="text" className="form-control" placeholder="Enter Banner Name" />
                        </div>
                     </div>

                     <div className="col-lg-6">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>Form Banner Heading <small>*</small></label>
                           </div>
                           <input value={postData?.banner_heading} onChange={handleChange} name="banner_heading" type="text" className="form-control" placeholder="Enter Banner Heading" />
                        </div>
                     </div>

                     <div className="col-lg-12">
                        <div className="add-page-inputs">
                           <div className="label-wrap-add">
                              <label>Form Banner Description <small>*</small></label>
                           </div>
                           <DynamicCKEditor data={postData.banner_description} onChange={(event, editor) =>
                              handleEditorChange("banner_description", editor.getData())} />
                        </div>
                     </div>
                  </div>
               </div>
            </form>
            <button type="submit" form="caseEdit" className="default-btn">publish <span></span></button>
         </div>
      </>
   );
}
